import templateUrl from 'emun.vendor/vendor-files.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import VendorFileDetails from 'emun.vendor/vendor-file-details'

class VendorFilesController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
			$ctrl.bus = new ServiceBus();
			//console.debug("VendorID", $ctrl.vendorId, $ctrl.$session.vendorGroup);
			if ($ctrl.$session.vendorGroup) {
				$ctrl.vendorId = undefined;
      }
		let options = {
			url: 'QueryVendorFiles.json' ,
			pageSize: 15,
			criteria: {
				VendorId: $ctrl.vendorId,
				NumDays: $ctrl.days
			},
			orderBy: '-AddedOn',
			autoLoad: true,
			append: false,
			hideLeftNav: true,
			filters: [
				{ groupBy: "isDownloaded", title: "Downloaded"},
				{ date: "addedOn", title: "Added On" }
			]
		};
		$ctrl.query = new AutoQuery(options);
		$ctrl.$on('$vendorFileDownloaded', () => $ctrl.query.load(true));
    }

    load() {
        const $ctrl = this;
        return $ctrl.query.load.apply($ctrl.query, arguments);
    }
	downloadFile(file) {
    const $ctrl = this;
    $ctrl.bus.send("DownloadVendorFile", file).then(res => $ctrl.$broadcast('$vendorFileDownloaded'));
    window.location = "https://emuncloud-staticassets.s3.amazonaws.com/customerDocuments/" + $ctrl.$session.clientId + "/VendorFiles/" + file.vendorId + "/" + file.fileName;
	}
	showDetails(file) {
		const $ctrl = this;
		return VendorFileDetails({ exportId: file.exportID });
	}

}

export default {
	bindings: {
		vendorId: '@',
		days: '@'
	},
    controller: VendorFilesController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};